export var TypeQuestTask;
(function (TypeQuestTask) {
    TypeQuestTask["ChoosePlayerName"] = "choosePlayerName";
    TypeQuestTask["CollectResource"] = "collectResource";
    TypeQuestTask["EarnResource"] = "earnResource";
    TypeQuestTask["FulfillContract"] = "fulfillContract";
    TypeQuestTask["HaveBuilding"] = "haveBuilding";
    TypeQuestTask["HaveExpansion"] = "haveExpansion";
    TypeQuestTask["HaveHappiness"] = "haveHappiness";
    TypeQuestTask["JoinCoop"] = "joinCoop";
    TypeQuestTask["SpendResource"] = "spendResource";
    TypeQuestTask["ReachPlayerLevel"] = "reachPlayerLevel";
    TypeQuestTask["StartProduction"] = "startProduction";
    TypeQuestTask["UseHumus"] = "useHumus";
    TypeQuestTask["MakePayment"] = "makePayment";
    TypeQuestTask["BuyImprovement"] = "buyImprovement";
    TypeQuestTask["UseOutskirt"] = "useOutskirt";
    TypeQuestTask["InviteFriends"] = "inviteFriends";
    TypeQuestTask["UseCookingStation"] = "useCookingStation";
    TypeQuestTask["UsePackage"] = "usePackage";
})(TypeQuestTask || (TypeQuestTask = {}));



//////////////////
// WEBPACK FOOTER
// ./src/features/info/quest/list/tasks/TypeQuestTask.ts
// module id = 2682
// module chunks = 3